import { useEffect } from 'react';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import RoadsListSearchbar from '../../widgets/searchbars/roadsListSearchbar/RoadsListSearchbar';
import { EmptyItem, PathItem, RaionWithRoadsItem, RoadWithPathsItem } from '../../widgets';
import { Loader } from '../../widgets/loaders/Loader';
import { setSearchLineIsShown } from '../../stateManagement/reducers';
import { useDispatch } from 'react-redux';
import { useGroupPaths } from './hooks/usePathsByRaions';
import { classNames } from 'primereact/utils';

// Страница отображения списка вариантов - "Выбор дороги и направления"
export function RoadsListPage() {
    const dispatch = useDispatch()
    const searchLineIsShown = useAppSelector(state => state.contentHeader.searchLineIsShown)

    const { pathsGroups, isLoading } = useGroupPaths();

    useEffect(() => {
        if (searchLineIsShown) {
            const roadsSearchbarDiv = document.getElementById("roads-list-searchbar-input")
            roadsSearchbarDiv?.focus()
        }
    }, [searchLineIsShown])

    useEffect(() => {
        return () => {
            dispatch(setSearchLineIsShown(false))
        }
    }, [])

    const roadListDivClassnames = classNames({
        "roads-list-div": true,
        "with-search-line": searchLineIsShown
    })

    return (
        <>
            <ContentHeader title="Выбор дороги и направления" type="search" />
            {searchLineIsShown && <RoadsListSearchbar />}
            <div className={roadListDivClassnames}>
                {isLoading
                    ?
                    <Loader />
                    :
                    <>
                        {pathsGroups && pathsGroups.map((pathsGroup: any) => {
                            const type = pathsGroup?.type
                            if (type === "raion") {
                                const { raionId, raionName, roads } = pathsGroup ?? {}
                                return <RaionWithRoadsItem key={`raion-${raionId}`} raionName={raionName} raionId={raionId} roads={roads} />
                            } else if (type === "road") {
                                const { roadId, roadName, paths } = pathsGroup ?? {}
                                return (
                                    <>
                                        {paths.length > 1 &&
                                            <RoadWithPathsItem key={`road-${roadId}`} roadId={roadId} roadName={roadName} paths={paths} isInRaion={false} />
                                        }
                                        {paths.length === 1 &&
                                            <PathItem key={`path-${paths[0]?.PathID}`} path={paths[0]} isInRaion={false} />
                                        }
                                    </>
                                )
                            }
                        })}
                        {pathsGroups && pathsGroups.length === 0 &&
                            <EmptyItem />
                        }
                    </>
                }
            </div>
        </>
    );
}

